import React from "react";

export default function ChartLoadingIcon({ style = {}, ...props }) {
  const defaultStyle = { width: 50 };

  return (
    <img
      src={require("assets/img/chartLoading.gif")}
      alt="Loading"
      style={{ ...defaultStyle, ...style }} // 合并默认样式和传入样式
      {...props}
    />
  );
}
